export default __webpack_public_path__ + "static/media/76c38392a9c58589c746640aa1d0b8571580988928668.c0d567c4.webp";